namespace OfficeGuy.Inputs {
    export class CreditCard {
        static InitEditors(Container = null) {
            $(".input-ShortText-CreditCard", Container)
                .off("input.creditcard")
                .on("input.creditcard", function () {
                    CreditCard.Format($(this));
                    return true;
                })
                .trigger("input.creditcard");
        }
        static Format($Input) {
            var OldValue = $Input.val();
            var NewValue = "";
            var Index = 0;
            for (var i = 0; i < OldValue.length; i++) {
                if (OldValue[i] < '0' || OldValue[i] > '9')
                    continue;

                if (Index != 0 && Index % 4 == 0)
                    NewValue += ' ';
                NewValue += OldValue[i];
                Index++;
            }

            var $Parent = $Input.parent();
            if ($Parent.hasClass("input-ShortText-CreditCard")) {
                var Regexes = {
                    Visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
                    MasterCard: /^5[1-5][0-9]{14}$/,
                    Amex: /^3[47][0-9]{13}$/,
                    Diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
                    Discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
                    JCB: /^(?:2131|1800|35\d{3})\d{11}$/
                }

                var Value = $Input.val().replace(/ /gi, '');
                $Parent
                    .toggleClass("input-ShortText-CreditCard-Amex", Regexes.Amex.test(Value))
                    .toggleClass("input-ShortText-CreditCard-Diners", Regexes.Diners.test(Value))
                    .toggleClass("input-ShortText-CreditCard-Visa", Regexes.Visa.test(Value))
                    .toggleClass("input-ShortText-CreditCard-Discover", Regexes.Discover.test(Value))
                    .toggleClass("input-ShortText-CreditCard-MasterCard", Regexes.MasterCard.test(Value))
                    .toggleClass("input-ShortText-CreditCard-JCB", Regexes.JCB.test(Value));
            }

            if ($Input.val() != NewValue)
                $Input.val(NewValue);
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.CreditCard.InitEditors(Container);
});